import React from "react";
import {
  FiltersSlice,
  GetTradesRequest,
  PrecisionConfig,
  QueryStatus,
  TradeData,
  TradesGeneralDataResponse,
} from "@shared/types";
import { SkipToken } from "@reduxjs/toolkit/query";
import { TradesTab } from "@shared/features/trades/common/types";

export const TradesPageContext = React.createContext<
  | {
      isOpenTrades: boolean;
      filtersSlice: FiltersSlice;
      getOpenTradesArgs: GetTradesRequest | undefined | SkipToken;
      getTradesQuery?: QueryStatus<TradesGeneralDataResponse<TradeData[]>>;
      getOpenTradesQuery?: QueryStatus<TradesGeneralDataResponse<TradeData[]>>;
      getClosedTradesQuery?: QueryStatus<
        TradesGeneralDataResponse<TradeData[]>
      >;
      filteredTradesData: TradeData[] | undefined;
      bulkActionTrades: TradeData[] | undefined;
      filteredOpenTradesData: TradeData[] | undefined;
      filteredClosedTradesData: TradeData[] | undefined;
      activeTrades: TradeData[] | undefined;
      waitingCancellationTrades: TradeData[] | undefined;
      isLoading: boolean;
      precisionConfig?: PrecisionConfig;
      pieChartData: any;
      isFetching: boolean;
      isUninitialized: boolean;
      isBacktesting?: boolean;
      tab?: TradesTab;
      inDrawer?: boolean;
    }
  | undefined
>(undefined);
